'use client';

import { ButtonPropsData } from '../Button/Button.types';
import { useButton } from '../Button/useButton';
import { Link } from './Link';

type LinkProps = React.ComponentPropsWithoutRef<'a'> & {
  label: string;
  openLinkInNewTab?: boolean;
  isDarkMode?: boolean;
  ariaLabel?: string;
  hasIcon?: boolean;
} & ButtonPropsData;

/**
 * Renders a next/link if internal link, anchor tag if external link
 */
export const LinkButton = ({
  href,
  openLinkInNewTab = true,
  style = 'link',
  hasArrow = false,
  size = 'small',
  className = '',
  isDarkMode = false,
  label,
  onClick = () => {},
  ariaLabel,
  hasIcon = false,
  ...props
}: LinkProps) => {
  const { buttonClassNames, buttonContent } = useButton({
    hasArrow,
    style,
    size,
    label,
    className,
    isDarkMode,
    hasIcon,
    openLinkInNewTab,
  });

  if (!href) {
    return null;
  }

  return (
    <Link
      href={href}
      target={openLinkInNewTab ? '_blank' : undefined}
      rel={openLinkInNewTab ? 'noopener noreferrer' : undefined}
      className={buttonClassNames}
      onClick={onClick}
      aria-label={ariaLabel ?? label}
      {...props}
    >
      {buttonContent}
    </Link>
  );
};
